export default {
  nav: {
    home: 'Home',
    manufacturers: 'Produttori',
    products: 'Prodotti',
    about: 'Chi siamo',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Contattaci',
    getQuote: 'Richiedi un preventivo',
  },
  langModal: {
    title: 'Siamo globali',
    chooseLocation: 'Scegli il tuo paese',
  },
  header: {
    email: "italy{'@'}gmgautomation.net",
    phone: '+39 040 957 1062',
    language: 'Italiano',
    searchPlaceholder: 'Cerca per codice articolo o produttore',
    noResults: 'Nessun pezzo trovato',
    enquiryLink: 'Invia una richiesta',
    enquiryLinkSub: 'Non trovi il tuo articolo? Contattaci',
  },
  quoteDrawer: {
    title: 'Inviaci una richiesta',
    parts: 'Codice articolo',
    addPart: 'Aggiungi un altro articolo',
  },
  home: {
    hero: {
      title: 'Cerca codici {highlight} e ricambi equivalenti per l’automazione industriale',
      highlight: 'obsoleti',
      subtitle:
        'Scopri la nostra vasta gamma di prodotti per tutte le tue esigenze, tra cui controller, PLC, HMI, motori, encoder, servoazionamenti, inverter, sistemi CNC e molto altro',
      searchPlaceholder: 'Inserisci il codice prodotto...',
      search: 'Cerca',
    },
    manufacturers: {
      title: 'Brand',
      subtitle:
        "Il nostro vasto inventario comprende migliaia di componenti per l'automazione provenienti dai principali costruttori OEM, rendendolo una soluzione unica per le vostre esigenze. Se una parte non è disponibile in stock, il nostro team multilingue si occuperá di procurare l'esatto componente di cui avete bisogno al prezzo più competitivo tramite la nostra larga rete di partner commerciali.",
      viewProducts: 'Vedi prodotti',
      viewAll: 'Vedi tutti i brand',
    },
    whyUs: {
      title: 'Perché scegliere GMG Automation?',
      subtitle: "I valori che ci rendono un partner affidabile nell'automazione industriale",
      quality: {
        title: 'Servizio di Qualità',
        description: 'Servizio clienti cordiale ed esperto per fornire soluzioni rapide ed efficienti.',
      },
      shipping: {
        title: 'Spedizione Express',
        description:
          'Consegna in giornata per le parti in magazzino o spedizione espressa tramite la nostra rete globale.',
      },
      warranty: {
        title: '12 Mesi di Garanzia',
        description:
          'Offriamo 12 mesi di garanzia su tutti gli articoli, siano essi nuovi, ricondizionati, riparati o in servizio permuta.',
      },
    },
    services: {
      title: 'Servizi',
      subtitle: 'Soluzioni complete per le vostre esigenze di ricambi per l’automazione industriale',
      learnMore: 'Scopri di più',
      supply: {
        title: 'Consegna',
        description:
          'Ci occupiamo di consegnare la tua parte dal nostro magazzino o dal nostro fornitore direttamente al tuo indirizzo.',
      },
      exchange: {
        title: 'Permuta',
        description:
          "Ritiriamo la tua unità difettosa in cambio di un'unità testata e funzionante a fronte di un sconto conveniente.",
      },
      repair: {
        title: 'Riparazione',
        description: 'Possiamo riparare migliaia di articoli a prezzi fissi.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Cerca produttori...',
    noResults: 'Nessun produttore trovato',
    hero: {
      title: 'Produttori',
      subtitle: 'Scopri la nostra ampia gamma di produttori e verifica la disponibilità di migliaia di prodotti',
      badges: {
        warranty: { title: 'Garanzia di 12 mesi', subtitle: 'Su tutti i componenti forniti' },
        response: { title: 'Risposta rapida', subtitle: 'Entro 24 ore' },
        delivery: { title: 'Consegna globale', subtitle: 'Spedizione in tutto il mondo' },
      },
    },
    products: {
      hero: {
        subtitle: 'Non trovi quello che stai cercando? Chiamaci o inviaci una richiesta',
      },
      searchPlaceholder: 'Cerca per numero di parte...',
      showingEntries: 'Visualizzazione di {from}–{to} di {total} parti',
      noResults: 'Nessuna parte trovata',
    },
  },
  about: {
    hero: {
      title: 'La nostra missione',
      subtitle: 'Trovare soluzioni veloci per i fermo macchina o per le lunghe tempistiche di conegna delle case madri',
    },
    values: {
      fast: {
        title: 'Veloce',
        desc: 'Siamo conosciuti per il nostro riscontro immediato e per venire incontro rapidamente alle vostre esigenze, aiutandovi a mantenere efficienti i vostri sistemi di automazione.',
      },
      friendly: {
        title: 'Semplice',
        desc: "Garantiamo un servizio semplice e senza stress, occupandoci di gestire noi tutte le fasi dell'ordine. Una volta trovata la parte di cui avete bisogno, pensiamo noi ad organizzare il servizio di spedizione e vi teniamo costantemente aggiornati sullo sviluppo dell'ordine. Il nostro impegno è rendere la vostra esperienza il più agevole possibile.",
      },
      experienced: {
        title: 'Professionale',
        desc: 'Scegli un servizio clienti impareggiabile con il nostro team dedicato sempre pronto ad assisterti, rendendo la tua esperienza con noi agevole e soddisfacente. Grazie alla nostra esperienza pluriennale nel settore possiamo offrire un servizio di alto livello, rendendoci il vostro partner ideale per soddisfare le vostre necessità.',
      },
      reliable: {
        title: 'Affidabile',
        desc: "L'affidabilità è la parte costante di ogni nostra operazione, sia nella fornitura di articoli di provata qualità, sia nella gestione dei vostri ordini.",
      },
    },
    story1: {
      title: 'Il team GMG Automation è consapevole dei bisogni delle piccole, medie e grandi aziende',
      text: 'GMG Automation ha a cuore le esigenze dei propri clienti che cercano soluzioni quando si verificano dei guasti alle loro macchine o quando hanno necessità di componenti obsolete. Grazie anche ad una grande rete di fornitori e partner commerciali in tutto il mondo, GMG è in grado di offrire articoli in tempi brevi e con condizioni economicamente molto vantaggiose. Scegli GMG Automation adesso per scoprirne tutti i vantaggi.',
    },
    story2: {
      title: 'Creare un servizio affidabile, sicuro e veloce',
      text: 'Con più di 10 anni di esperienza nel settore dell’automazione e un team multilingue a tua disposizione possiamo aiutarti a risolvere il tuo fermo macchina.',
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Rimani aggiornato con le ultime notizie e approfondimenti del nostro team',
    },
    empty: 'Nessun articolo trovato.',
    back: 'Torna al blog',
    label: 'Articolo',
    related: 'Altri articoli',
  },
  faq: {
    hero: {
      title: 'FAQ',
      subtitle: 'Scopri le domande frequenti',
    },
    search: 'Cerca nelle domande frequenti',
    empty: 'Nessuna domanda frequente trovata.',
  },
  contact: {
    hero: {
      title: 'Contattaci',
      subtitle:
        'In GMG Automation siamo più di semplici rivenditori di ricambi per l’automazione: siamo partner impegnati nel vostro successo. Con un team dedicato e multilingue a vostra disposizione, siamo pronti ad assistervi per qualsiasi richiesta',
    },
    offices: {
      title: 'I nostri uffici',
    },
    form: {
      title: 'Contattaci',
      name: 'Nome',
      company: "Nome dell'azienda",
      email: 'Indirizzo e-mail',
      nameRequired: 'Il nome è obbligatorio.',
      companyRequired: "Il nome dell'azienda è obbligatorio.",
      emailRequired: "L'e-mail è obbligatoria.",
      phoneRequired: 'Il telefono è obbligatorio.',
      phone: 'Numero di telefono',
      phonePlaceholder: 'Es. +39 02 1234 5678',
      message: 'Fornisci i dettagli della tua richiesta',
      send: 'Invia',
      sending: 'Invio in corso...',
      successTitle: 'Messaggio inviato',
      successDetail: 'Ti risponderemo il prima possibile.',
      errorTitle: 'Errore',
      errorDetail: 'Qualcosa è andato storto. Per favore riprova.',
    },
    plantAddresses: {
      title: 'Indirizzo e coordinate bancarie',
      regNumber: "Numero di registrazione dell'azienda",
      phone: 'Telefono',
      bankDetails: 'Coordinate bancarie',
      beneficiary: 'Beneficiario',
    },
  },
  terms: {
    hero: {
      title: 'Termini e Condizioni',
    },
    empty: 'Nessun termine e condizione trovato.',
  },
  privacy: {
    hero: {
      title: 'Informativa sulla Privacy',
    },
    empty: 'Nessuna informativa sulla privacy trovata.',
  },
  cookie: {
    hero: { title: 'Politica sui Cookie' },
    empty: 'Nessuna politica sui cookie trovata.',
    banner: {
      message:
        "Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito. Continuando a navigare, accetti l'uso dei cookie.",
      learnMore: 'Politica sui Cookie',
      necessaryOnly: 'Solo necessari',
      acceptAll: 'Accetta tutto',
    },
  },

  product: {
    manufacturer: 'Brand',
    partNumberLabel: 'Codice articolo',
    noDescription: 'Nessuna descrizione disponibile',
    inStock: 'In Stock',
    available: 'Disponibile',
    qty: 'Quantità',
    addToCart: 'Aggiungi al carrello',
    addedToCart: 'Aggiunto al carrello',
    enquiryTitle: 'Richiesta Rapida',
    warrantyText: 'Tutti i prodotti sono coperti da una garanzia di 12 mesi.',
    fetchError: 'Impossibile caricare il prodotto.',
    trust: {
      warranty: '12 mesi di garanzia su tutti i prodotti',
      shipping: 'Consegna rapida in tutto il mondo',
      support: 'Assistenza clienti professionale',
    },
    features: {
      quality: 'Prodotto di qualità',
      delivery: 'Spedizione rapida',
      warranty: 'Garanzia di 12 mesi',
    },
    tabs: {
      description: 'Descrizione',
      warranty: 'Garanzia',
    },
  },

  enquiryForm: {
    companyName: 'Nome Azienda',
    yourName: 'Nome',
    email: 'Email',
    country: 'Seleziona il paese',
    partNumber: 'Codice articolo',
    quantity: 'Quantità',
    send: 'Invia',
    phoneInput: {
      placeholder: 'Telefono',
      searchPlaceholder: 'Ricerca',
    },
    successTitle: 'Richiesta inviata',
    successDetail: 'Ti contatteremo al più presto.',
    errorTitle: 'Qualcosa è andato storto',
    errorDetail: 'Per favore riprova più tardi.',
  },

  searchEnquiry: {
    title: 'Risultati di ricerca per',
    whatNext: {
      title: "Dopo l'invio della tua richiesta",
      step1Title: '1. Email di Conferma',
      step1Text: 'Riceverai un’email di conferma che attesta la ricezione della tua richiesta.',
      step2Title: '2. Account Manager Dedicato',
      step2Text: 'Sarai contattato dal nostro team per confermare i dettagli della tua richiesta.',
      step3Title: '3. Il tuo Preventivo',
      step3Text: 'Riceverai un preventivo completo basato sulle tue esigenze specifiche.',
      legal: 'Tutti gli ordini sono soggetti alla disponibilità del prodotto.',
      legalLink: 'Consulta i nostri Termini e Condizioni.',
      askTeam: 'Contatta il nostro team',
      emailLabel: 'Email',
    },
  },

  cart: {
    title: 'Carrello richieste',
    empty: 'Il tuo carrello è vuoto',
    emptySub: 'Aggiungi parti dalle pagine prodotto per iniziare',
    browse: 'Cerca articoli',
    itemCount: '{count} articolo | {count} articoli',
    partNumber: 'Codice articolo',
    availability: 'Disponibilità',
    quantity: 'Quantità',
    clearAll: 'Svuota tutto',
    clearTitle: 'Svuota carrello',
    clearConfirm: 'Sei sicuro di voler rimuovere tutti gli articoli dal carrello?',
    clear: 'Svuota',
    cancel: 'Annulla',
    enquirySubtitle: '{count} articolo nella tua richiesta | {count} articoli nella tua richiesta',
    addedTitle: 'Aggiunto al carrello',
    addedDetail: '{partNumber} è stato aggiunto al tuo carrello richieste',
  },

  footer: {
    contact: {
      title: 'Altri modi per Contattarci',
      subtitle: 'Contattaci telefonicamente o inviando un form online e saremo lieti di aiutarti!',
      formTitle: 'Invia un modulo online',
      formSubtitle: 'Condividi le tue esigenze e ti risponderemo entro 24 ore.',
      enquiry: 'Invia richiesta',
      callTitle: 'Chiamaci',
      callSubtitle: 'Parla direttamente con il nostro team multilingue.',
    },
    sections: {
      manufacturers: 'Produttori',
      quickLinks: 'Link rapidi',
      connect: 'Contatti',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Tutti i diritti riservati',
      privacy: 'Informativa sulla privacy',
      terms: 'Termini e condizioni',
    },
    recaptcha: 'Protetto da reCAPTCHA',
    recaptchaPrivacy: 'Privacy',
    recaptchaTerms: 'Termini',
    disclaimer:
      'GMG Automation non è un distributore o rappresentante autorizzato dei marchi presenti in questo sito. I marchi registrati e i nomi su questo sito appartengono ai rispettivi proprietari.',
  },

  common: {
    noResults: 'Nessun risultato',
  },

  validation: {
    required: 'Questo campo è obbligatorio',
    emailInvalid: 'Inserisci un indirizzo e-mail valido',
    tooLong: 'Non deve superare i {max} caratteri',
    recaptchaError: 'La verifica reCAPTCHA non è riuscita. Per favore riprova.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Ricambi per Automazione Industriale',
      description: 'Trova ricambi obsoleti e correnti per l\'automazione industriale. Cerca per codice articolo e richiedi un preventivo entro 24 ore. Controller, PLC, HMI, servoazionamenti e molto altro.',
    },
    manufacturers: {
      title: 'Produttori — GMG Automation',
      description: 'Sfoglia i ricambi per automazione industriale per produttore. Siemens, ABB, Schneider Electric, Fanuc e centinaia di altri. Spedizione rapida in tutto il mondo con garanzia 12 mesi.',
    },
    about: {
      title: 'Chi Siamo — GMG Automation',
      description: 'Oltre 10 anni di esperienza nei ricambi per automazione industriale. Team multilingue, rete globale di fornitori, risposta rapida e garanzia 12 mesi su tutti i componenti.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Resta aggiornato con le ultime notizie, approfondimenti del settore e articoli tecnici dal team di GMG Automation.',
    },
    faq: {
      title: 'FAQ — GMG Automation',
      description: 'Risposte alle domande frequenti su ordini, spedizioni, pagamenti e garanzia di GMG Automation.',
    },
    contact: {
      title: 'Contattaci — GMG Automation',
      description: 'Contatta il team di GMG Automation. Chiamaci, invia un modulo di richiesta o scrivici direttamente. Rispondiamo entro 24 ore.',
    },
    terms: {
      title: 'Termini e Condizioni — GMG Automation',
      description: 'Leggi i termini e le condizioni che regolano l\'utilizzo dei servizi di GMG Automation e l\'acquisto di ricambi industriali.',
    },
    privacy: {
      title: 'Informativa sulla Privacy — GMG Automation',
      description: 'Scopri come GMG Automation raccoglie, utilizza e protegge i tuoi dati personali in conformità con le normative sulla privacy.',
    },
    cookie: {
      title: 'Cookie Policy — GMG Automation',
      description: 'Scopri i cookie utilizzati sul sito di GMG Automation e come gestire le tue preferenze.',
    },
    product: {
      description: 'Acquista {partNumber} di {manufacturer}. Richiedi un preventivo per consegna rapida in tutto il mondo. Garanzia 12 mesi inclusa.',
    },
    manufacturerProducts: {
      description: 'Sfoglia ricambi e componenti di automazione {manufacturer}. Cerca per codice articolo e richiedi un preventivo con spedizione rapida in tutto il mondo.',
    },
  },
}
